import * as angular from "angular";
import {IController, ITimeoutService} from "angular";
import {AccountModel} from "../../angular/models/account.model";
import {ViewSettingsModel} from "../../../commons/models/view-settings.model";
import * as _ from "lodash";
import {SiteFiltersType} from "../../../commons/types/site-filters.type";
import {QuickFilterContextService} from "../../../commons/services/quick-filter-context.service";
import {ViewFilterSettingsService} from "../../../commons/services/view-filter-settings.service";
import {BringozLoaderService} from "../../../commons/services/bringoz-loader.service";
import {CommonsAlertsService} from "../../../commons/services/commons-alerts.service";
import {ConfirmDialogService} from "../../../commons/services/confirm-dialog.service";
import {SplitService} from "../../../commons/services/split-service.service";
import {ShippersAlertsService} from "../../../shippers/services/shippers-alerts.service";
import {ShippersDialogService} from "../../../shippers/services/shippers-dialog-service.service";
import {ShippersRequestsService} from "../../../shippers/services/shippers-requests.service";

export class AccountShippersViewCtrl implements IController {

  account: AccountModel;
  isActive: boolean;
  selectedQuickFilterId?: string;

  public pageName: string;
  public filtersConfig: any;
  private loadLimit: number;
  private infiniteScroll: any;
  private shippersRef: any;

  /* @ngInject */
  constructor(private $log, private $infiniteScroll, private $shippers, private $state,
              private $mdDialog, private splitService: SplitService, private $timeout: ITimeoutService,
              private confirmDialogService: ConfirmDialogService, private bringozLoaderService: BringozLoaderService, private quickFilterContextService: QuickFilterContextService, private ShippersService,
              private shippersRequestsService: ShippersRequestsService, private shippersAlertsService: ShippersAlertsService,
              private shippersDialogService: ShippersDialogService, private $shipper, private commonsAlertsService: CommonsAlertsService, private viewFilterSettingsService: ViewFilterSettingsService) {
    this.loadLimit = 20;
    this.shippersRef = this.$shippers();
    this.pageName = $state.current.name;
  }

  $onInit() {
    this.filtersConfig = {
      queryString: undefined,
      includeFilters: [
        SiteFiltersType.isActive
      ],
      bringozFilters: {
        [SiteFiltersType.isActive]: this.isActive,
      }
    }

    this.shippersRef.$query(this._getQueryPayload());
    this.infiniteScroll = this.$infiniteScroll(this.shippersRef, this.loadLimit);
  }

  submitQuery(queryString) {
    this.filtersConfig.queryString = queryString;
    this._query();
  }

  addShipper(event, account) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../../views/dialogs/add-new-shipper-to-account-dialog.tmpl.html').default,
      controller: function ($scope, $shippers, $mdDialog, $log, commonsService) {
        const shippersRef = $shippers();

        $scope.createUser = {};
        $scope.inviteUser = null;
        $scope.passwordPolicy = self.splitService.getSitePasswordPolicy();
        $scope.zxExtras = [];

        $scope.accountUserIds = [];
        $scope.loading = false;

        $scope.cancel = self.$mdDialog.cancel;
        $scope.onUserChange = onUserChange;
        $scope.create = create;
        $scope.onPasswordChange = onPasswordChange;

        /////////////////////////////////////////////////////////////////

        function onUserChange(user) {
          $scope.createUser = user;
          $scope.zxExtras = user?.email ?
            commonsService.buildZxExtras(user.email) :
            [];
        }

        function create(form) {
          form.$setSubmitted(true);
          if (form.$valid) {
            $scope.loading = true;
            let payload = {
              accountId: account.id,
              user: $scope.createUser
            };
            shippersRef.$put(payload).then(
              (shipper) => {
                $mdDialog.hide(shipper);
              },
              (error) => {
                $scope.loading = false;
                $log.error('Failed PUT to server, ' +
                  'accountShippersView@addShipper@create', error);
              }
            );
          }
        }

        function onPasswordChange(password) {
          $scope.createUser.password = password;
        }

      },
      targetEvent: event,
      clickOutsideToClose: false
    }).then(
      (shipper) => {
        this._query();
      },
      () => {
        this.$log.info('Dialog Closed');
      }
    );
  }

  addShipperAPIKey(event, account: AccountModel) {
    this.shippersDialogService.createShipperAPI(event, account)
      .then((shipperApi) => {
          this._createShipperApi(event, shipperApi);

        },
      )
      .catch((error) => {
        this.$log.info('Dialog Closed');
      })
  }

  addExistingShipper(event, account) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../../views/dialogs/add-existing-shipper-to-account-dialog.tmpl.html').default,
      controller: function ($scope, $shippers, $mdDialog, $log) {
        const shippersRef = $shippers();

        $scope.cancel = self.$mdDialog.cancel;
        $scope.selectedShipper = null;
        $scope.add = add;
        $scope.onSelectShipper = onSelectShipper;

        /////////////////////////////////////////////////////////////////

        function onSelectShipper(shipperId) {
          shippersRef.$asyncValues([shipperId]).then(shippers => $scope.selectedShipper = shippers[0]);
        }

        function add() {
          if ($scope.selectedShipper) {
            let payload = {
              accountId: account.id,
              user: $scope.selectedShipper.user
            };
            shippersRef.$put(payload).then(
              (shipper) => {
                $mdDialog.hide(shipper);
              },
              (error) => {
                $scope.loading = false;
                $log.error('Failed PUT to server, ' +
                  'accountShippersView@addShipper@create', error);
              }
            );
            $mdDialog.hide($scope.selectedShipper);
          }
        }
      },
      targetEvent: event,
      clickOutsideToClose: false
    }).then(
      (shipper) => {
        this._query();
      },
      () => {
        this.$log.info('Dialog Closed');
      }
    );
  }


  onOpen($mdMenu, ev) {
    this.$timeout(0).then(() => {
      $mdMenu.open(ev);
    });
  }

  onDeleteShipper(shipper, $event) {
    let loading = false;
    const text = 'Are you sure you want to delete this shipper?';
    this.confirmDialogService.confirmMask('Delete Shipper', text, $event)
      .then((shouldMask) => {
        loading = true;
        this.bringozLoaderService.on();
        return this.shippersRequestsService.deleteShipper(shipper.id, shouldMask)
      })
      .then((response) => {
        this._query();
        this.shippersAlertsService.deleteOneSuccess(shipper);
      })
      .catch((error) => {
        if (error) {
          this.shippersAlertsService.deleteOneError();
          this.$log.error('Failed to delete shipper @shippersListView@onDeleteShipper', error);
        } else {
          this.$log.info('Dialog Closed');
        }
      })
      .finally(() => {
        if (loading) {
          this.bringozLoaderService.off();
        }
      })
  }

  onActivateOrDeactivateShipper(shipper, $event) {
    this.shippersDialogService.onActivateOrDeactivateShipper(shipper, $event)
      .then(() => {
        this.bringozLoaderService.on();
        this.$shipper(shipper.id).$update(shipper)
          .then(() => {
            this.commonsAlertsService.preferencesByNameSuccess('User Status');
          })
          .catch((error) => {
            this.commonsAlertsService.preferencesError();
          })
          .finally(() => {
            this.bringozLoaderService.off();
          })
      })
      .catch(() => {
        this.$log.info('Dialog Closed');
      })
  }

  onQuickFilterSelect(quickFilter: ViewSettingsModel) {
    if (!!quickFilter) {
      this.onFiltersChange(quickFilter.settings, quickFilter);
    } else {
      const filters = angular.copy(this.filtersConfig.bringozFilters);
      _.forOwn(filters, (value, key) => {
        filters[key] = _.isArray(value) ? [] : undefined;
      })
      this.onFiltersChange(filters);
    }
  }

  onFiltersChange(filters, selectedQuickFilter?) {
    this.viewFilterSettingsService.setActiveQuickFilter(selectedQuickFilter, this.pageName);
    this.selectedQuickFilterId = selectedQuickFilter?.id;
    this.filtersConfig.bringozFilters = filters;

    this.submitQuery(this.filtersConfig.queryString);
    this._setStateParams();
  }


  // ******************************
  //        Private methods
  // ******************************

  _getQueryPayload() {
    return {
      accountId: this.account.id,
      active: this.filtersConfig.bringozFilters.isActive,
      query: this.filtersConfig.queryString,
      limit: this.loadLimit
    };
  }

  _query() {
    this.shippersRef.$query(this._getQueryPayload())
      .then(() => {
        this.infiniteScroll.reload();
      }, (resp) => {
        this.$log.debug('Fail to $query', resp);
      });
  }

  private _setStateParams() {
    this.$state.go('.', {
      isActive: this.filtersConfig.bringozFilters.isActive,
      selectedQuickFilterId: this.selectedQuickFilterId
    }, {notify: false, reload: false, location: 'replace'});
  }

  private _createShipperApi(event, shipper) {
    this.ShippersService.addShipperApi(shipper)
      .then((createdShipper) => {
        this._query();
        this._showShipperAPI(event, createdShipper)
      })
  }

  private _showShipperAPI(event, shipper) {
    this.shippersDialogService.showShipperAPI(event, shipper);
  }

}

angular
  .module('bringoz.admin.accounts')
  .component('accountShippersView', {
    bindings: {
      account: '<',
      isActive: '<?',
      selectedQuickFilterId: '<?'
    },
    template: require('./account-shippers-view.html').default,
    controller: AccountShippersViewCtrl
  });
